module.exports = __webpack_public_path__ + "media/crypto/yfi-a99f9c9b.png";